import { useI18nContext } from "@i18n/i18n-react";
import { Badge } from "@shadcn/ui/badge";
import { Button } from "@shadcn/ui/button";
import { formatToCurrency } from "@utils/currency";
import { Plus } from "lucide-react";
import { toast } from "sonner";
import { useCart } from "~/contexts/CartContext";

type AddToBagButtonProps = {
	hubProductId: string;
	price: number;
	stock: number;
	onClick: () => void;
	disabled?: boolean;
};

export const AddToBagButton = (props: AddToBagButtonProps) => {
	const { hubProductId, price, stock, onClick, disabled } = props;
	const useCartStore = useCart();
	const addToCart = useCartStore((state) => state.addToCart);
	const updateQuantity = useCartStore((state) => state.updateQuantity);
	const cartItem = useCartStore((state) => state.items.find((item) => item.id === hubProductId));
	const i18n = useI18nContext().LL["new-ui"];

	const handleAddToBag = () => {
		if (cartItem) {
			const newQuantity = cartItem.quantity + 1;
			if (newQuantity > stock) {
				toast.error(i18n.CANNOT_ADD_MORE_STOCK({ stock }));
				return;
			}
			updateQuantity(hubProductId, newQuantity);
		} else {
			if (stock > 0) {
				addToCart(hubProductId, price, 1, stock);
			} else {
				toast.error(i18n.PRODUCT_OUT_OF_STOCK());
				return;
			}
		}
		onClick();
	};

	const isMaxReached = cartItem && cartItem.quantity >= stock;

	return (
		<Button className="w-full font-breit font-normal" size="lg" onClick={handleAddToBag} disabled={disabled || isMaxReached}>
			{(!cartItem || cartItem.quantity < stock) && <Plus className="size-4" />}
			{cartItem ? (cartItem.quantity < stock ? i18n.ADD_ANOTHER_ONE() : i18n.IN_BAG({ quantity: cartItem.quantity })) : i18n.ADD_TO_BAG()}
			<Badge variant="secondary" className="font-breit text-xs font-semibold leading-4">
				{formatToCurrency(price)}
			</Badge>
		</Button>
	);
};
